/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ConfirmationContent = styled.div`
  padding: 16px 16px 4px;
  text-align: center;
`;

export const ConfirmationIcon = styled.div`
  color: #f5a623;

  svg {
    width: 58px;
    height: 58px;
  }
`;

export const ConfirmationTitle = styled.h2`
  margin: 12px 0 0;
  color: #102033;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
`;

export const ConfirmationText = styled.p`
  max-width: 340px;
  margin: 12px auto 0;
  color: ${({ theme }) => theme.black40};
  font-size: 15px;
  line-height: 1.65;
`;

export const ConfirmationActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  padding: 20px 16px 24px;
`;

export const ConfirmationButton = styled.button`
  min-width: 120px;
  padding: 10px 20px;
  border: 1px solid ${({ $confirm, theme }) => ($confirm ? theme.primary : theme.black10)};
  border-radius: 4px;
  background-color: ${({ $confirm, theme }) => ($confirm ? theme.primary : theme.white)};
  color: ${({ $confirm, theme }) => ($confirm ? theme.white : theme.black80)};
  box-shadow: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;

  &:hover {
    border-color: ${({ $confirm, theme }) => ($confirm ? theme.primary80 : theme.black20)};
    background-color: ${({ $confirm, theme }) => ($confirm ? theme.primary80 : theme.black5)};
  }

  &:disabled {
    border-color: ${({ theme }) => theme.black10};
    background-color: ${({ $confirm, theme }) => ($confirm ? theme.primary40 : theme.black5)};
    color: ${({ $confirm, theme }) => ($confirm ? theme.white : theme.black20)};
    cursor: default;
  }
`;

const getColor = ({ error, theme }) => {
  if (error) {
    return `color: ${theme.firebrick};`;
  }

  return `color: ${theme.primary};`;
};

const getDisabledButton = ({ disabled, theme }) => {
  if (disabled) {
    return `
    color: ${theme.black20};
    cursor: auto;
  `;
  }

  return `
    &:hover {
      background-color: ${theme.black5};
      border-radius: 5px;
    }
  `;
};

export const ButtonStyled = styled.button`
  align-items: center;
  justify-content: center;
  min-width: 64px;
  border: none;
  text-transform: uppercase;
  padding: 6px 16px;
  line-height: 1.75;
  cursor: pointer;
  font-weight: bold;
  letter-spacing: 0.02857em;
  background-color: ${({ theme }) => theme.white};
  box-shadow: none;
  ${getColor}
  ${getDisabledButton}
`;
